import React from 'react';
import PropTypes from 'prop-types';
import { DEFAULT_USER_AVATAR } from '../../constants';
import Styles from './styles';

const UserAvatar = props => (
  <div
    style={Object.assign({}, Styles.avatar, {
      width: props.size,
      height: props.size,
      backgroundImage: `url(${props.src || DEFAULT_USER_AVATAR})`,
    })}
  />
);

UserAvatar.propTypes = {
  src: PropTypes.string,
  size: PropTypes.number,
};

UserAvatar.defaultProps = {
  src: 'http://cf.ltkcdn.net/socialnetworking/images/std/168646-425x425-Cat-Avatar-Primary.jpg',
  size: 40,
};

export default UserAvatar;



// WEBPACK FOOTER //
// ./src/components/UserAvatar/index.js